import { PaginatedData } from "src/library/utils";
import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";
import useAxios from "src/core/shared/hooks/useAxios";
import { IProcessJob } from "src/core/process-job/api/processJobs.api";

import {
  ISupportTicket,
  ListSupportTicketParams
} from "../../support/api/support.api";

// Entity types

export interface ICreditRequest {
  id: number;
  supportTicketId: number;
  orderId: number;
  orderLineId: number;
  requestedByUserId: number;
  reviewedByUserId?: number | null;
  quantityRequested: number;
  quantityApproved?: number | null;
  creditRequestReasonCodeId: number;
  status: CreditRequestStatus;
  exported: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export enum CreditRequestStatus {
  PendingApproval = "pending_approval",
  Approved = "approved",
  PartiallyApproved = "partially_approved",
  Rejected = "rejected"
}

export interface ICreditRequestReasonCode {
  id: number;
  code: string;
  name: string;
  description?: string | null;
}

export interface GetOrderCreditParams {
  orderId: number;
}

export interface SupportTicketWithCreditRequestParams extends ListSupportTicketParams {
  /** JSON stringified array of credit request statuses */
  status?: string;
}

type CreditRequestEndpointConfig = {
  GET_CREDIT_REQUESTS_BY_ORDER: EndpointConfig<
    GetOrderCreditParams,
    ICreditRequest[]
  >;
  LIST_CREDIT_REQUEST_SUPPORT_TICKETS: EndpointConfig<
  SupportTicketWithCreditRequestParams,
    PaginatedData<ISupportTicket>
  >;

  EXPORT_CREDITS: EndpointConfig<
    null,
    IProcessJob
  >;
};

// supportTicket api specific logic

const BASE_URL = `${process.env.REACT_APP_API_URL}/credit-request`;

const requests: RequestConfig<CreditRequestEndpointConfig> = {
  GET_CREDIT_REQUESTS_BY_ORDER: ({ orderId }) => ({
    url: `${BASE_URL}/order/${orderId}`,
    method: "GET"
  }),

  LIST_CREDIT_REQUEST_SUPPORT_TICKETS: params => ({
    url: `${BASE_URL}/tickets`,
    method: "GET",
    params
  }),

  EXPORT_CREDITS: () => ({
    url: `${BASE_URL}/export`,
    method: "POST"
  })

};

export const useCreditRequestApi: UseApiRequest<CreditRequestEndpointConfig> = name => useAxios(requests[ name ], name);
